import styled from 'styled-components'

export const TabContainer = styled.div`
  height: 100%;
  background: var(--tds-grey);
`
